import { createContext, useContext, type ReactNode } from 'react';
import type { ParentMessagingPort } from '@s2w/core';

const ParentMessagingContext = createContext<ParentMessagingPort | null>(null);

export interface ParentMessagingProviderProps {
  readonly port: ParentMessagingPort;
  readonly children: ReactNode;
}

export const ParentMessagingProvider = ({ port, children }: ParentMessagingProviderProps) => (
  <ParentMessagingContext value={port}>{children}</ParentMessagingContext>
);

export const useParentMessaging = (): ParentMessagingPort | null =>
  useContext(ParentMessagingContext);
